<template>
    <div class="wrapper"
         :class="[
			{ 'nav-open': $sidebar.showSidebar },
		  	{ rtl: $route.meta.rtlActive }
    	]">
        <notifications></notifications>
        <side-bar :active-color="sidebarBackground"
                  :background-image="sidebarBackgroundImage"
                  :data-background-color="sidebarBackgroundColor"
                  :closeButton="false"
                  titleRoute="caDashboard"
        >
            <template slot="links">
                <sidebar-item :link="{ name: 'Accueil', icon: 'home', path: 'dashboard', route: 'caDashboard' }"></sidebar-item>
                <sidebar-item :link="{ name: 'Documents', icon: 'folder-open', path: 'documents', route: 'caDocuments' }"></sidebar-item>
                <sidebar-item :link="{ name: 'Prestations', icon: 'layer-group', path: 'services', route: 'caServices' }"></sidebar-item>
                <sidebar-item :link="{ name: 'Interventions', icon: 'cubes', path: 'interventions', route: 'caInterventions' }"></sidebar-item>
                <sidebar-item :link="{ name: 'Analyse des tendances', icon: 'poll', path: 'trends', route: 'caTrends' }" v-if="user ? user.is_accessible_trend : false"></sidebar-item>
                <sidebar-item :link="{ name: 'Audits/Bilans', icon: 'lightbulb', path: 'audits', route: 'caAudits' }" v-if="user ? user.is_accessible_audit : false"></sidebar-item>
            </template>
        </side-bar>
        <div class="main-panel">
            <navbar></navbar>

            <div class="ca-content" :class="{ content: !$route.meta.hideContent }"
                 @click="toggleSidebar">
                <zoom-center-transition :duration="200" mode="out-in">
                    <!-- your content here -->
                    <router-view/>
                </zoom-center-transition>
            </div>
            <Footer></Footer>
        </div>
    </div>
</template>

<script>
import Navbar from "@/components/ClientsArea/Navbar";
import Footer from "@/components/ClientsArea/Footer";
import Vuex from "vuex";

export default {
    name: "ClientsAreaLayout",
    components: {
        Navbar, Footer
    },
    data() {
        return {
            sidebarBackgroundColor: "black",
            sidebarBackground: "purple",
            sidebarBackgroundImage: process.env.VUE_APP_APP_BASE_URL + "/img/sidebar-2.jpg",
            sidebarMini: false,
            sidebarImg: false,
            image: process.env.VUE_APP_APP_BASE_URL + '/img/laravel-vue.svg',
            roles: []
        };
    },
    methods: {
        toggleSidebar() {
            if (this.$sidebar.showSidebar) {
                this.$sidebar.displaySidebar(false);
            }
        },
        minimizeSidebar() {
            if (this.$sidebar) {
                this.$sidebar.toggleMinimize();
            }
        },
        async getProfile() {
            await this.$store.dispatch("caGetClient")
        }
    },
    created() {
        this.getProfile();
    },
    mounted() {
        document.title = 'Gaia - Espace client'
    },
    computed: {
        ...Vuex.mapState({
            user: state => state.caAuth.client
        })
    },
    watch: {
        me: {
            handler: function(val) {
                this.roles = val.roles.map(r => r.name)
                this.user = val.name
            },
            deep: true
        },
        sidebarMini() {
            this.minimizeSidebar();
        }
    }
}
</script>

<style scoped lang="scss">
$scaleSize: 0.95;
@keyframes zoomIn95 {
    from {
        opacity: 0;
        transform: scale3d($scaleSize, $scaleSize, $scaleSize);
    }
    to {
        opacity: 1;
    }
}

.main-panel .zoomIn {
    animation-name: zoomIn95;
}
@keyframes zoomOut95 {
    from {
        opacity: 1;
    }
    to {
        opacity: 0;
        transform: scale3d($scaleSize, $scaleSize, $scaleSize);
    }
}

.main-panel .zoomOut {
    animation-name: zoomOut95;
}
</style>
